<template>
    <div
        class="graph-submenu uk-position-top-right uk-position-small uk-border-rounded uk-padding-small uk-animation-fast uk-display-inline-block"
        :class="{
            active: activeSubmenu,
            'uk-box-shadow-medium': activeSubmenu,
        }"
    >
        <ul v-if="activeSubmenu" class="uk-list uk-animation-fast" :class="{ 'uk-animation-fade': activeSubmenu }">
            <li>
                <a href="" class="uk-link-text uk-text-middle">
                    <img
                        class="uk-margin-small-right uk-text-muted uk-text-middle"
                        :src="require('@/assets/images/icons/icon-pencil.svg')"
                    />
                    Edit
                </a>
            </li>
            <li>
                <a href="" class="uk-link-text uk-text-middle" @click="toggleConfirm">
                    <img
                        class="uk-margin-small-right uk-text-muted uk-text-middle"
                        :src="require('@/assets/images/icons/icon-delete.svg')"
                    />
                    Delete
                </a>
            </li>
            <li>
                <a href="" class="uk-link-text uk-text-middle">
                    <img
                        class="uk-margin-small-right uk-text-muted uk-text-middle"
                        :src="require('@/assets/images/icons/icon-help.svg')"
                    />
                    Help
                </a>
            </li>
        </ul>
        <a
            class="uk-position-top-right uk-margin-small-top uk-margin-small-right uk-text-muted uk-icon-link submenu-hover"
            :class="{ 'extra-padding': !activeSubmenu }"
            uk-icon="icon: more-vertical; ratio: 0.8"
            @click="toggle('activeSubmenu')"
        >
        </a>

        <confirm-box v-if="showConfirm" :text="confirmMessage" @confirmed="remove" />
    </div>
</template>

<script lang="js">
import ConfirmBox from "../../ConfirmBox.vue";

export default {
    name: "GraphSubmenu",
    components: {
        ConfirmBox,
    },
    props: {
        position: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            activeSubmenu: false,
            confirmMessage: "Are you sure you want to delete this graph?",
            showConfirm: false,
        };
    },
    methods: {
        toggle(property) {
            this[property] = !this[property];
        },
        toggleConfirm(event) {
            event.preventDefault();
            this.showConfirm = !this.showConfirm;
        },
        remove(confirmed) {
            if (confirmed) {
                this.$store.dispatch("graphs/removeGraph", this.position);
            }
            this.showConfirm = false;
            this.activeSubmenu = false;
        },
    },
};
</script>
